// @i18n-ignore-file
'use client'
import { useEffect } from 'react'

import {
  CONFIG_GLADLY_HELP_CENTER_CDN,
  GLADLY_API_URL,
  GLADLY_ORG_ID,
  GLADLY_SDK_URL,
  GLADLY_CA_API_URL,
  GLADLY_CA_ORG_ID,
  GLADLY_CA_SDK_URL,
  CONFIG_GLADLY_BRAND_ID_FOR_US,
  CONFIG_GLADLY_BRAND_ID_FOR_CANADA,
  CONFIG_GLADLY_BRAND_ID_FOR_CANADA_FR,
} from '@src/config/env'
import {
  LOCALE_STANDARD_FORMAT,
  LOCALE_STANDARD_FORMAT_CANADA,
  LOCALE_STANDARD_FORMAT_CANADA_FRENCH,
} from '@src/config/localisation/locale-config.constants'
import { getLocalisationDataFromStorage } from '@src/utils/general.utils'
import { getNonce } from '@src/utils/nonce.utils'

const GLADLY_BRAND_ID = {
  [LOCALE_STANDARD_FORMAT]: CONFIG_GLADLY_BRAND_ID_FOR_US,
  [LOCALE_STANDARD_FORMAT_CANADA]: CONFIG_GLADLY_BRAND_ID_FOR_CANADA,
  [LOCALE_STANDARD_FORMAT_CANADA_FRENCH]: CONFIG_GLADLY_BRAND_ID_FOR_CANADA_FR,
}

// Helper function to get Gladly configuration based on locale
export const getGladlyConfig = () => {
  const localizationData = getLocalisationDataFromStorage()

  if (localizationData?.country === 'CA') {
    return {
      apiUrl: GLADLY_CA_API_URL,
      orgId: GLADLY_CA_ORG_ID,
      sdkUrl: GLADLY_CA_SDK_URL,
      // @ts-expect-error -- TAbsoluteLocaleStandard not accepted as index; CA locale is always en-CA or fr-CA
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- locale key lookup; CA locale is en-CA or fr-CA
      brandId: GLADLY_BRAND_ID[localizationData.locale],
    }
  }

  // Default to US configuration
  return {
    apiUrl: GLADLY_API_URL,
    orgId: GLADLY_ORG_ID,
    sdkUrl: GLADLY_SDK_URL,
    // @i18n-ignore
    // eslint-disable-next-line i18next/no-literal-string
    brandId: GLADLY_BRAND_ID[LOCALE_STANDARD_FORMAT],
  }
}

// create a custom hook
export const useGladlyHelpCenter = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // @i18n-ignore
      const CONFIG_ID = 'gladly-chat-widget-install'
      // @i18n-ignore
      const SCRIPT_ID = 'gladly-help-center-sdk'

      const gladlyConfig = getGladlyConfig()
      const apiUrl = gladlyConfig.apiUrl
      const orgId = gladlyConfig.orgId
      const sdkUrl = gladlyConfig.sdkUrl
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- brandId from getGladlyConfig()
      const brandId = gladlyConfig.brandId
      const nonce = getNonce()

      const configScript = document.createElement('script')
      configScript.id = CONFIG_ID
      configScript.innerHTML = ` window.gladlyHCConfig = { api: '${apiUrl}', orgId: '${orgId}', brandId: '${brandId}', cdn: '${CONFIG_GLADLY_HELP_CENTER_CDN}', selector: '#gladly-help-center', autoShowButton: false };` // # nosemgrep

      const sdkScript = document.createElement('script')
      sdkScript.id = SCRIPT_ID
      sdkScript.innerHTML = `function l() { var t = document, e = t.createElement('script'); (e.type = 'text/javascript'), (e.async = !0), (e.src = '${sdkUrl}'); var a = t.getElementsByTagName('script')[0]; a.parentNode.insertBefore(e, a); } var w = window; w.attachEvent ? w.attachEvent('onload', l) : w.addEventListener('DOMContentLoaded', l, !1); l(); ` // # nosemgrep

      if (nonce) {
        configScript.setAttribute('nonce', nonce)
        sdkScript.setAttribute('nonce', nonce)
      }

      document.head.appendChild(configScript)
      document.head.appendChild(sdkScript)
    }

    return () => {
      window.gladlyHCLoaded = false
    }
  }, [])
}
